import * as Styles from "./styles.css";
import { cn } from "@discovery/classnames";
export const StepIndicator = ({ maxStep, currentStep, onClick, containerStyle, }) => {
    const indicators = [];
    for (let index = 0; index < maxStep; index++) {
        indicators.push(React.createElement("div", { key: index, className: index === currentStep ? Styles.active : Styles.inactive, onClick: () => onClick(index) }));
    }
    return (React.createElement("div", { className: cn(Styles.container, containerStyle), id: "#indicator" }, indicators));
};

